import React from "react";
import "../styles/personalStats.css";

const PersonalStats = () => {
    return (
        <div id="personalStats">
            <h1>MATEO PAEZ LVL 24
            </h1>
            <div id="personalStats_lines">
                <span id="thick_personal_line"></span>
                <span id="thin_personal_line"></span>
            </div>
            <h2>Web Developer</h2>
        </div>
    );
};

export default PersonalStats;